<template>
<v-owl-carousel
    v-cloak
    v-if="items.length > 0"
    :responsive="{0:{items:1,nav:false,dots:true}, 500: {items:2, nav:false, dots:true}, 768: {items:3, nav:false, dots:true}, 1200:{items:4, nav:false, dots:false}}"
>
    <div 
        class="home-carousel__content__item"
        v-for="(item, index) in items" :key="index"
        style="margin:5px;"
    >
        <home-course-card :courseprop="item"></home-course-card>
    </div>
</v-owl-carousel>
</template>

<script>
    import HomeCourseCard from '../home/HomeCourseCard';


    export default {
        name: 'homecarousel',
        components: {
            HomeCourseCard,
        },
        props: {
            items: {
                type: Array,
                required: true
            },
            countProp: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                active: 0,
                count: 4
            }
        },
        mounted() {
            let self = this;
            this.resizeCount();

            window.addEventListener('resize', function () {
                self.resizeCount();
            });
        },
        methods: {
            resizeCount() {
                if (window.innerWidth > 1200)
                    this.count = 4;
                else {
                    if (window.innerWidth <= 500) {
                        this.count = 1;
                    } else if (window.innerWidth <= 768 && window.innerWidth >= 500) {
                        this.count = 2;
                    } else {
                        this.count = 3;
                    }
                }
            },
            prev() {
                if (this.items.length <= this.count) return;
                if (this.active === 0) {
                    this.active = this.items.length - this.count;
                } else {
                    this.active--;
                }
            },
            next() {
                if (this.items.length <= this.count) return;
                if (this.active === this.items.length - this.count) {
                    this.active = 0;
                } else {
                    this.active++;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/home/HomeCarousel.vue